/* Topbar desktop/mobile */
const header = document.querySelector('.shopify-section--header');
const topBar = document.querySelector('.shopify-section--header-top-nav');
if (header && topBar) {
    const mobileQuery = window.matchMedia("screen and (max-width: 1149px)");

    const handleTopBarPosition = () => {
        if (mobileQuery.matches) {
            // Mobile : déplacer topBar dans le footer du menu mobile
            let panelFooter = document.querySelector('#header-sidebar-menu .panel-footer');

            if (!panelFooter) {
                panelFooter = document.createElement('div');
                panelFooter.classList.add('panel-footer', 'v-stack', 'gap-5');
                let navMobileWrapper = document.getElementById('header-sidebar-menu');
                navMobileWrapper = navMobileWrapper.querySelector('.panel-list__wrapper > .panel > .panel__wrapper');
                if (navMobileWrapper) {
                    navMobileWrapper.appendChild(panelFooter);
                }
            }

            if (!panelFooter.contains(topBar)) {
                panelFooter.appendChild(topBar);
            }

        } else {
            // Desktop : replacer topBar au-dessus du header
            if (header.parentElement && header.previousElementSibling !== topBar) {
                header.parentElement.insertBefore(topBar, header);
            }
        }
    };

    // Appel initial
    handleTopBarPosition();

    // Réagir aux changements de taille d'écran
    mobileQuery.addEventListener('change', handleTopBarPosition);
}

/* Show Hide */
function showHide() {
    const showHideContents = document.querySelectorAll('.show-hide-content');
    showHideContents.forEach((showHideContent) => {
        // Récupération de la hauteur initiale du bloc
        const heightInit = showHideContent.offsetHeight;
        showHideContent.style.maxHeight = 'none';
        const maxHeight = showHideContent.offsetHeight;
        showHideContent.style.maxHeight = '';

        // Afficher/Masquer les boutons d'action
        const buttons = showHideContent.nextElementSibling;
        if (heightInit < maxHeight) {
            buttons.style.display = 'block';
        } else {
            buttons.style.display = 'none';
        }

        // Clic sur les boutons d'action
        if (!buttons.dataset.listener) {
            buttons.addEventListener('click', () => {
                showHideContent.classList.toggle('show');

                if (showHideContent.classList.contains('show')) {
                    showHideContent.style.cssText = "--max-height: " + maxHeight + "px";
                } else {
                    showHideContent.style = "";
                }
            });

            buttons.dataset.listener = "true";
        }
    });
}
showHide();

function debounce(fn, wait = 300) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(...args), wait);
  };
}

window.addEventListener('resize', debounce(() => showHide(), 500));

/* =========================================================
   Helpers
========================================================= */

const html = document.documentElement;
let isUpdating = false;
let lastDomUpdate = 0;
let bestSellerIdsAbortController = null;

function onReady(fn) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fn);
  } else {
    fn();
  }
}

/* =========================================================
   Language handling
========================================================= */

function getLang() {
  return html.getAttribute("lang");
}

function updateLanguageVisibility() {
  const lang = getLang();
  const elements = document.querySelectorAll(".only-fr");

  elements.forEach(el => {
    const shouldHide = !/^fr(?:-|$)/i.test(lang || "");
    if (el.classList.contains("hidden") !== shouldHide) {
      el.classList.toggle("hidden", shouldHide);
    }
  });
}

/* =========================================================
   Canonical (pagination)
========================================================= */

function removeCanonicalOnPagination() {
  if (!window.location.search.includes("page=")) return;

  const canonical = document.querySelector('link[rel="canonical"]');
  if (canonical) canonical.remove();
}

/* =========================================================
   Title update (AJAX pagination - collection & blog)
========================================================= */

function getPageLabel() {
  const lang = getLang();
  const pageLabels = window.themeVariables?.pageLabels || {};
  return pageLabels[lang] || pageLabels[lang.split('-')[0]] || pageLabels['en'] || 'Page';
}

function updateTitleForPagination(titleSelector, paginationSelector) {
  const titleEl = document.querySelector(titleSelector);
  const pagination = document.querySelector(paginationSelector);
  if (!titleEl || !pagination) return;

  const baseTitle = titleEl.dataset.baseTitle || titleEl.textContent;
  titleEl.dataset.baseTitle = baseTitle;

  const page = pagination.dataset.currentPage;
  const pageLabel = getPageLabel();
  const newTitle =
    page && page !== "1"
      ? `${baseTitle} - ${pageLabel} ${page}`
      : baseTitle;

  if (titleEl.textContent !== newTitle) {
    titleEl.textContent = newTitle;
    document.title = newTitle;
  }
}

const updateCollectionTitle = () => updateTitleForPagination("#collection-title", "#collection-pagination");
const updateBlogTitle = () => updateTitleForPagination("#blog-title", "#blog-pagination");

/* =========================================================
   Best-selling badge sync
========================================================= */

async function getBestSellerIds(collectionHandle, signal) {
  const res = await fetch(`/collections/${collectionHandle}?sort_by=best-selling&view=ajax`, { signal });

  if (!res.ok) {
    throw new Error(`Best-seller request failed: ${res.status}`);
  }

  return await res.json();
}

async function applyBestSellerBadges() {
  const bestSellerScopes = Array.from(document.querySelectorAll('[data-best-seller-collection-handle], [data-best-seller-collection-handles]'));
  const fallbackCollectionHandle = window.location.pathname.split('/collections/')[1]?.split('/')[0];

  if (bestSellerScopes.length === 0 && !fallbackCollectionHandle) return;

  if (bestSellerIdsAbortController) {
    bestSellerIdsAbortController.abort();
  }

  bestSellerIdsAbortController = new AbortController();

  try {
    const getScopeHandles = (scope) => {
      const handlesFromList = (scope.getAttribute('data-best-seller-collection-handles') || '')
        .split(',')
        .map((handle) => handle.trim())
        .filter(Boolean);

      if (handlesFromList.length > 0) {
        return [...new Set(handlesFromList)];
      }

      const singleHandle = scope.getAttribute('data-best-seller-collection-handle');
      return singleHandle ? [singleHandle] : [];
    };

    const handles = [...new Set(bestSellerScopes.flatMap((scope) => getScopeHandles(scope)))];

    if (handles.length === 0 && fallbackCollectionHandle) {
      handles.push(fallbackCollectionHandle);
    }

    const bestSellerIdsByHandle = new Map();

    await Promise.all(handles.map(async (handle) => {
      const ids = await getBestSellerIds(handle, bestSellerIdsAbortController.signal);
      bestSellerIdsByHandle.set(handle, ids);
    }));

    const badgeTemplate = document.getElementById('best-selling-badge-template')?.content?.firstElementChild;
    const bestSellerIdsForHandles = new Map();

    const getBestSellerIdsForHandles = (scopeHandles) => {
      const handlesKey = [...scopeHandles].sort().join(',');

      if (!bestSellerIdsForHandles.has(handlesKey)) {
        bestSellerIdsForHandles.set(handlesKey, [...new Set(scopeHandles.flatMap((handle) => bestSellerIdsByHandle.get(handle) || []))]);
      }

      return bestSellerIdsForHandles.get(handlesKey);
    };

    const scopesToProcess = bestSellerScopes.length > 0 ? bestSellerScopes : [document];

    scopesToProcess.forEach((scope) => {
      const scopeHandles = scope === document ? [fallbackCollectionHandle].filter(Boolean) : getScopeHandles(scope);
      const cards = scope.matches('[data-product-id]') ? [scope] : Array.from(scope.querySelectorAll('[data-product-id]'));

      cards.forEach(card => {
        const cardHandles = card === scope ? scopeHandles : getScopeHandles(card);
        const handlesToUse = cardHandles.length > 0 ? cardHandles : scopeHandles;
        const bestSellerIds = getBestSellerIdsForHandles(handlesToUse);
        const id = Number(card.getAttribute('data-product-id'));
        const isBestSeller = bestSellerIds.includes(id);

        let badgeList = card.querySelector('.product-card__badge-list');

        if (!badgeList && isBestSeller) {
          badgeList = document.createElement('div');
          badgeList.className = 'product-card__badge-list only-fr hidden';
          card.insertBefore(badgeList, card.firstChild);
        }

        const existingBestSellerBadge = badgeList?.querySelector('best-selling-badge');

        if (isBestSeller) {
          const hasDiscountBadge = badgeList?.querySelector('on-sale-badge');
          if (badgeTemplate && badgeList && !existingBestSellerBadge && !hasDiscountBadge) {
            badgeList.appendChild(badgeTemplate.cloneNode(true));
          }
        } else {
          if (existingBestSellerBadge) {
            existingBestSellerBadge.remove();
          }
        }
      });
    });

    updateLanguageVisibility();
  } catch (error) {
    if (error?.name !== 'AbortError') {
      console.error('Best-seller badge sync failed:', error);
    }
  }
}

/* =========================================================
   Skeepers anchor fix
========================================================= */

function initSkeepersReviewAnchorFix() {
  document.addEventListener("click", (event) => {
    const reviewLink = event.target.closest('a[href="#skeepers_product_widget"]');
    if (!reviewLink) return;

    const targetAnchor = document.getElementById("skeepers_product_widget_anchor")
      || document.getElementById("skeepers_product_widget");

    if (!targetAnchor) return;

    event.preventDefault();
    targetAnchor.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });

    if (window.history?.replaceState) {
      window.history.replaceState(null, "", "#skeepers_product_widget_anchor");
    }
  });
}

/* =========================================================
   Global observer
========================================================= */

function observeDom() {
  const updateLangDebounced = debounce(() => updateLanguageVisibility(), 50);
  const applyBestSellerBadgesDebounced = debounce(() => applyBestSellerBadges(), 120);

  const observer = new MutationObserver(() => {
    // Toujours relancer la visibilité langue après chaque mutation DOM (ex: après AJAX tri)
    updateLangDebounced();
    applyBestSellerBadgesDebounced();

    if (isUpdating) return;

    const now = Date.now();
    if (now - lastDomUpdate < 300) return;  // Throttle : 300ms min

    isUpdating = true;
    lastDomUpdate = now;

    requestAnimationFrame(() => {
      // Only update titles/canonical when relevant pagination elements exist
      const hasCollection = !!document.querySelector('#collection-pagination');
      const hasBlog = !!document.querySelector('#blog-pagination');

      if (hasCollection) updateCollectionTitle();
      if (hasBlog) updateBlogTitle();

      // Remove canonical only for paginated collection/blog pages
      if ((hasCollection || hasBlog) && window.location.search.includes('page=')) {
        removeCanonicalOnPagination();
      }

      isUpdating = false;
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

/* =========================================================
   Init
========================================================= */

onReady(() => {
  updateLanguageVisibility();
  applyBestSellerBadges();
  updateCollectionTitle();
  updateBlogTitle();
  removeCanonicalOnPagination();
  initSkeepersReviewAnchorFix();

  // observe language attribute only
  new MutationObserver(updateLanguageVisibility).observe(html, {
    attributes: true,
    attributeFilter: ["lang"]
  });

  // observe DOM once
  observeDom();

  document.addEventListener('variant:change', () => {
    updateLanguageVisibility();
  });
});
